export default __webpack_public_path__ + "static/media/cat-4-5.6d514ed0.png";